import React, { FunctionComponent } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Asset } from 'contentful';

import { friendlyDate } from '../../../helpers/dateTime';


type Props = {
    image: Asset,
    date: string,
    title: string,
    slug: string
};

const BlogPostTile: FunctionComponent<Props> = ({ image, date, title, slug }) => {

    return (
        <Link href={`/insights/${slug}`}>
            <a className='flex flex-col grow py-4'>
                <div className="flex flex-col grow rounded overflow-hidden shadow-lg">
                    <Image
                        src={`https:${image.fields.file.url}`}
                        className='flex-1'
                        alt={image.fields.description}
                        width={300}
                        height={200}
                        objectFit="cover"
                    />
                    <div className="flex-1 px-2 pt-4 pb-2">
                        <div className="seo-copy uppercase mb-2">{friendlyDate(date)}</div>
                        <div className="sub-heading-medium">
                            {title}
                        </div>
                    </div>
                    <div className="px-2 pt-2 pb-4">
                        <Image
                            src='/icons/chevron-right.png'
                            alt='View post'
                            width={40}
                            height={40}
                        />
                    </div>
                </div>
            </a>
        </Link>
    );
};

export default BlogPostTile;